export const TaskManagerTemplateGidByCategoryIdRemote: { [key: number]: string } | null = await import(
  'tasktracker/CreateTaskModal'
)
  .then(res => res.default.TASK_MANAGER_TEMPLATE_GID_BY_CATEGORY_ID || null)
  .catch(() => null)
